import React, { useState, useRef, useCallback, useImperativeHandle, forwardRef } from 'react';
import Keyboard from '@components/KeyboardV2';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import 'react-simple-keyboard/build/css/index.css';
import cn from 'classnames';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
 
const CashCalculator = forwardRef(({
  maxLength,
  name,
  value,
  placeholder,
  onChange,
  currenySymbol,
  setshowCalculator,
  showCalculator,
  isCounter,
  serverAppTheme,
  setAmount,
  preDefinedvalue, 
  cashMode,
  callbackToUpdateInputs,
  isDriveThru,
  isLandScapeMode
}, ref) => {

  // State Management
  const [inputName, setInputName] = useState(`${name}`);
  const [inputs, setInputs] = useState({});
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  // Refs for props that are recreated on every parent render — keeps onClickBtn stable
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const preDefinedvalueRef = useRef(preDefinedvalue);
  preDefinedvalueRef.current = preDefinedvalue;

  // Methods
  const handleBlur = () => {
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const changeState = (newState) => {
    setInputs(newState);
  };

  callbackToUpdateInputs(changeState);
  const onClickBtn = useCallback((e) => {
    const currentInputs = inputsRef.current;
    const currentInputName = inputName;
    const values =
      e !== '{bin}' && { ...currentInputs, [currentInputName]: currentInputs[currentInputName] && preDefinedvalueRef.current ? currentInputs[currentInputName].concat(e) : ''.concat(e)};
    setInputs({
      ...currentInputs,
      [currentInputName]: values[currentInputName]
    });

    if (e === '{bin}') {
      onChangeRef.current('0.00');
    } else {
      onChangeRef.current(Number(values[currentInputName]));
    }
  }, [inputName]);

  useImperativeHandle(
    ref,
    () => ({
      setKeyboardValue: () => {
      }
    }),
    []
  );

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]:''
    });
  };

  // HTML CSS CODE
  return (
    <>
      {![0, 1, 3].includes(cashMode) && (
        <div className={cn("p-0 row mx-0 w-100")} style={{ height: (!isCounter) && '17%' }}>
          {(isCounter) && (value === `${currenySymbol}0.00`) && <label htmlFor={name} className='fs-28 fw-500 position-absolute ' style={{ left: '8px', marginTop: '11px' }}> <span>$</span> <span style={{ color: '#ACABAB' }}> Tap to enter amount</span></label>}
          <input
            id={name}
            type="text"
            name={name}
            className={cn('w-100 h-89 form-control p-2 pl-3 fs_26 fw-500 text-left', styles.inputFild)}
            style={{ fontFamily: 'Poppins', height: '60px', background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text }}
            placeholder={placeholder}
            value={(isCounter) && (value === `${currenySymbol}0.00`) ? '' : value}
            onFocus={() => { handleBlur(); setInputName(`${name}`); }}
          />
          {(inputs[name]?.length > 0) && (
            <div
              role="presentation"
              className="position-absolute mt-2"
              style={{ right: '10px' }}
              onClick={() => { setInputName(name); setEmpty(name); window.sessionStorage.setItem('CashStorage', '0.00'); setAmount('0.00') }}
            >
              <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" />
            </div>
          )}
        </div>
      )}
      {<div className={cn('px-0 h-100')}>
       
          <Keyboard
            onClickBtn={onClickBtn}
            type={'numeric'}
            isClr
            btnSize="btn35"
            maxLength={maxLength}
            customClass={'fs-30 mr-1 py-1 pl-1'}
            customizeKeyBoard={`${isLandScapeMode ? styles.keyboardHeightLandscape : styles.keyboardHeightHorizontal} mb-1`}
            screenType="cashCalculator"
          />
      </div>}
    </>
  );
});

CashCalculator.propTypes = {
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  currenySymbol: PropTypes.string,
  setshowCalculator: PropTypes.func,
  showCalculator: PropTypes.bool,
  isCounter: PropTypes.bool,
  serverAppTheme: PropTypes.shape({
    inputBg: PropTypes.string,
    inputBorder_Bottom: PropTypes.string,
    primary_text: PropTypes.string,
    iconcolor: PropTypes.string
  }),
  setAmount: PropTypes.func,
  preDefinedvalue: PropTypes.bool,
  cashMode: PropTypes.number,
  callbackToUpdateInputs: PropTypes.func.isRequired,
  isDriveThru: PropTypes.bool,
  isLandScapeMode: PropTypes.bool
};

CashCalculator.defaultProps = {
  maxLength: 10,
  placeholder: '',
  currenySymbol: '$',
  showCalculator: false,
  isCounter: false,
  preDefinedvalue: false,
  cashMode: 0,
  isDriveThru: false,
  isLandScapeMode: false,
  serverAppTheme: {}
};


export default CashCalculator;
